import api from "./client";
export async function getProjects(params = {}) {
    const res = await api.get("/admin/projects", { params });
    return res.data;
}
export async function getProject(id) {
    const res = await api.get(`/admin/projects/${id}`);
    return res.data;
}
export async function createProject(data) {
    const res = await api.post("/admin/projects", data);
    return res.data;
}
export async function updateProject(id, data) {
    const res = await api.put(`/admin/projects/${id}`, data);
    return res.data;
}
export async function deleteProject(id) {
    await api.delete(`/admin/projects/${id}`);
}
export async function getAllProjects() {
    const res = await api.get("/admin/projects/all");
    return res.data.items;
}
